import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Community } from '@models/communities/community.model';
import { EngagementPlanModalComponent } from '../engagement-plan-modal/engagement-plan-modal.component';
import { ICommunityService } from '@tokens/injection.tokens';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResetMobileAppPasswordComponent } from '../reset-mobile-app-password/reset-mobile-app-password.component';
import { Resident } from '@models/account/resident.model';
import { ResidentSnapshotModalComponent } from '../resident-snapshot-modal/resident-snapshot-modal.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@environments/environment';
import moment from 'moment';

@Component({
  selector: 'app-resident-header',
  templateUrl: './resident-header.component.html',
  styles: [],
})
export class ResidentHeaderComponent {
  protected readonly environment = environment;
  api = inject(CommonVerbsApiService);

  mm = moment;
  communityService = inject(ICommunityService);
  modal = inject(NgbModal);
  toastr = inject(ToastrService);
  community: Community = this.communityService.model ?? <Community>{};
  brookdaleInd = false;

  resident: Resident = this.route.snapshot.data.resident;
  details = `/communities/${this.community.id}/residents/${this.resident.id}`;
  edit = `/communities/${this.community.id}/residents/forms/${this.resident.id}`;
  forms = `/communities/${this.community.id}/residents/${this.resident.id}/form`;
  stories = `/communities/${this.community.id}/residents/${this.resident.id}/stories`;
  landing = `/account/${this.resident.id}`;
  back = this.router.isActive(this.details, true);

  constructor(private route: ActivatedRoute, private router: Router) {
    if (this.community?.corporation.id === environment.brookdaleCorpId)
      this.brookdaleInd = true;

    //
  }

  resetMobileAppPassword() {
    const modal = this.modal.open(ResetMobileAppPasswordComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
    });
  }

  copy(text: string | undefined | null) {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.toastr.success('Copied');
      });
    }
  }

  engagementPlan() {
    const modal = this.modal.open(EngagementPlanModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
    });
    modal.componentInstance.resident = this.resident;
  }

  residentSnapshot() {
    const modal = this.modal.open(ResidentSnapshotModalComponent, {
      centered: true,
      size: 'md',
      backdrop: 'static',
    });
    modal.componentInstance.resident = this.resident;
  }

  printAppCard() {
    this.api.download<Blob>(`users/${this.resident.id}/app-card`).subscribe({
      next: response => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `App_Card_${this.resident.id}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: err => {
        console.error('Error al descargar el PDF:', err);
      },
    });
  }
}
